<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <ListadoPublicaciones></ListadoPublicaciones>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import ListadoPublicaciones from '../components/ListadoPublicaciones.vue';
export default {
    name: 'PostsView',
    components: {
        ColumnaIzquierda,
        ListadoPublicaciones,
    }
}
</script>